<template>
  <div class="presentation">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'presentation',
  props: {
    activeSlide: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      cursor: null,
    };
  },
  methods: {
    scanSlides() {
      return (this.$children || []).filter((child) => child._isVue && child._IS_COMPONENT__SLIDE);
    },
  },
  watch: {
    activeSlide(newValue) {
      this.cursor = newValue;
    },
    cursor(newValue) {
      this.scanSlides().forEach((slide) => (slide.visible = slide.zIndex <= newValue));
    },
  },
  created() {
    this.cursor = this.activeSlide;
  },
};
</script>
